import styled from 'styled-components';
import { palette } from 'styled-theme';
import WithDirection from '@iso/lib/helpers/rtl';

const BankAccountPageWrapper = styled.div`
  .PageContent {
    .OrderInfo {
      width: 100%;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-flex-flow: row wrap;
      -ms-flex-flow: row wrap;
      flex-flow: row wrap;
      -webkit-align-items: baseline;
      -webkit-box-align: baseline;
      -ms-flex-align: baseline;
      align-items: baseline;
      -webkit-box-pack: justify;
      -webkit-justify-content: space-between;
      -ms-flex-pack: justify;
      justify-content: space-between;

      @media (max-width: 560px) {
        flex-direction: column;
      }

      .Title {
        font-size: 16px;
        font-weight: 500;
        color: ${palette('grey', 8)};
        margin: 0 0 20px;
        line-height: 1;
      }

      .LeftSideContent {
        .LeftSideContentInput {
          > div {
            &::before {
              background-color: #ececec;
            }
          }
        }
      }
    }

    .LeftSideContent {
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-align-items: flex-start;
      -webkit-box-align: flex-start;
      -ms-flex-align: flex-start;
      align-items: flex-start;
      -webkit-flex-direction: column;
      -ms-flex-direction: column;
      flex-direction: column;
      &.LeftSideContentInput {
        > div {
          &::before {
            background-color: #ececec;
          }
        }
      }
    }
    .isoExampleWrapper {
      margin: 0
    }
    .ant-row{
      margin-top: 12px
    }
  }
  .ButtonWrapper {
    width: 100%;
    display: flex;
    justify-content: ${(props) =>
      props['data-rtl'] === 'rtl' ? 'flex-start' : 'flex-end'};
    margin-top: 30px;
  }
  .PageFooter {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;

    .saveBtn {
      background: ${palette('blue', 14)};
      margin: ${(props) =>
        props['data-rtl'] === 'rtl' ? '0 15px 0 0' : '0 0 0 15px'};
    }
  }
`;

const Fieldset = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 2px;
  &:last-child {
    margin-bottom: 0;
  }
`;

const Label = styled.label`
  font-size: 13px;
  color: ${palette('text', 1)};
  line-height: 1.5;
  font-weight: 500;
  padding: 0;
  margin: 0 0 2px 0;
`;

export { Fieldset, Label };
export default WithDirection(BankAccountPageWrapper);
